export const demo09 = {
  "appBar": {
    "backgroundColor": "#B8C7C4",
    "mode": "light",
    "exhibition": {
      "name": "Fra marinedykking til nordsjødykking",
      "description": "Tidligere dykker John A. Haugestad var i sin karriere som offshoredykker ansatt i flere firma, blant annet Three X, Scan Dive og Willco. Han arbeidet også på utleie for Ocean Systems og Comex (begge disse også på Ekofisk) og J. C. Doris.",
      "url": "https://ekofisk.industriminne.no/nb/fra-marinedykking-til-nordsjodykking/"
    },
    "museum": {
      "name": "Virtuelt Museum",
      "url": "https://virtueltmuseum.no"
    }
  },
  "sections": [
    {
      "title": "Forside",
      "type": "sticky",
      "order": 1,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU2js?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 4,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Overskrift",
              "text": "{\"blocks\": [{\"key\": \"48385\", \"text\": \"Fra marinedykking til nordsjødykking\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 36, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 36, \"style\": \"FONT_SIZE_48\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Forfatter",
              "text": "{\"blocks\": [{\"key\": \"bbce6\", \"text\": \"Av Nettartikkel\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 15, \"style\": \"FONT_SIZE_16\"}, {\"offset\": 0, \"length\": 15, \"style\": \"color-555555\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Ingress",
              "text": "{\"blocks\": [{\"key\": \"5ede4\", \"text\": \"Tidligere dykker John A. Haugestad var i sin karriere som offshoredykker ansatt i flere firma, blant annet Three X, Scan Dive og Willco. Han arbeidet også på utleie for Ocean Systems og Comex (begge disse også på Ekofisk) og J. C. Doris.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 237, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 237, \"style\": \"FONT_SIZE_20\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Scroll instruks",
              "text": "{\"blocks\": [{\"key\": \"ead42\", \"text\": \"SCROLL FOR Å LESE\\n↓\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_12\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            }
          ]
        },
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"157cc\", \"text\": \"INNLEDNING\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"8f5da\", \"text\": \"Interessen for «undervannsverdenen» ble vakt da jeg på midten av 1950-tallet, 13 år gammel, for første gang fikk se gjennom en ...\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 130, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 130, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 130, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 2,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"0318f\", \"text\": \"Innledning\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"38c44\", \"text\": \"Interessen for «undervannsverdenen» ble vakt da jeg på midten av 1950-tallet, 13 år gammel, for første gang fikk se gjennom en lånt dykkermaske, forteller Haugestad. – Jeg anskaffet sporenstreks min egen maske, snorkel og svømmeføtter for penger tjent den sommeren på luking, hesjing og høylasstråkking. Resten av den sommeren og de følgende somrene brukte jeg dette utstyret så ofte jeg kunne, og så langt ut mot høsten som sjøtemperaturen tillot. Jeg ble ganske god i fridykking, men kom aldri så dypt som jeg kunne tenke meg. Jeg var vel egentlig hekta på dykking allerede fra første titt i dykkermasken. Utdannelse / yrkesvalg ble til å begynne med noe annerledes. Først et å til sjøs for å prøve dette, og å se verden. Dernest Infanteriets befalsskole i et år, påfulgt av seks års tjeneste som befal på åremålskontrakter, hovedsakelig som troppssjef i Infanteriet (Brigade Nord). I løpet av denne tiden tok jeg et sportsdykkerkurs, skaffet meg det nødvendige utstyret og dykket tidvis på ren hobbybasis.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 1008, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 1008, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Fra sportsdykker til marinedykker",
      "type": "sticky",
      "order": 3,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU33X?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"74b90\", \"text\": \"FRA SPORTSDYKKER TIL MARINEDYKKER\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 33, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 33, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 33, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"1a470\", \"text\": \"– Da de seks årene i Hæren var til endes, var valget av videre yrke og utdannelse ganske naturlig.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 98, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 98, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 98, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 4,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"a448e\", \"text\": \"Fra sportsdykker til marinedykker\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 33, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 33, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 33, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"71f0a\", \"text\": \"– Da de seks årene i Hæren var til endes, var valget av videre yrke og utdannelse ganske naturlig. Var så heldig å få opptak på Marinens Dykker og Froskemannsskole (DFS) Haakonsvern, Bergen. I så måte var for mitt vedkommende veien kort fra militært yrkesliv i skog og på fjellvidde, til et yrkesliv under vann. Jeg arbeidet deretter som hjelmdykker på diverse anlegg, mest i Nord-Norge, i cirka tre år.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 403, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 403, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Eventyr i Nordsjøen",
      "type": "sticky",
      "order": 5,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTe1P5Z?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"c584e\", \"text\": \"EVENTYR I NORDSJØEN\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 19, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"d085f\", \"text\": \"Kanskje luktet det litt mer «eventyr» av dette.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 47, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 47, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 47, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 6,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"14149\", \"text\": \"Eventyr i Nordsjøen\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 19, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"db721\", \"text\": \"– Hvorfor valgte du å arbeide i oljeindustrien? – Etter å ha jobbet tre års tid primært som hjelmdykker på diverse anlegg, og etter å ha utført i praksis de fleste arbeidsoppgavene som forekommer i den forbindelsen, kastet jeg mine øyne på dette nye som foregikk i Nordsjøen. Sant å si virket den dypere dykkingen, de mer avanserte metodene og utstyret, faglig sett mer spennende og utfordrende. Kanskje luktet det litt mer «eventyr» av dette. Jeg begynte å arbeide i petroleumsrelatert dykking i mars/april 1972. Først på Ekofisktanken i byggefasen i Gandsfjorden (Hillevåg). Dette var kort tid etter utslep fra «byggehølet» i Jåttavågen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 639, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 639, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"9f200\", \"text\": \"– Hvilken utdanning/kvalifikasjoner trengte du for å få jobben? – Det som på sett og vis ble et antiklimaks for meg da jeg vel var begynt i petroleumsrelatert dykking, var oppdagelsen av at formelle krav til utdanning og til faglige kvalifikasjoner i bunn og grunn ikke eksisterte. (Til motsetning fra det miljøet jeg kom fra, hvor sertifisering var en klar forutsetning for å få jobb). Her ble det derimot bare sett på som en fordel om man hadde faglig bakgrunn fra før, men det var tydeligvis ikke avgjørende.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 511, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 511, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"96ae2\", \"text\": \"Folk med bakgrunn fra Marinen; marinejegere, minedykkere, lettdykkere, sivile hjelmdykkere som meg selv, og folk med et vanlig sportsdykkerkurs, i noen tilfeller ikke engang det, gikk om hverandre. Ute på jobb var det aldri snakk dykkerne imellom om hvem som hadde hvilken bakgrunn. Det avgjørende for den enkeltes anseelse innad i miljøet var om man mestret oppgavene.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 369, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 369, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Dykking på Gulftide",
      "type": "sticky",
      "order": 7,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUhhh?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"6da11\", \"text\": \"DYKKING PÅ GULFTIDE\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 19, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"d7a3b\", \"text\": \"Videre var jeg en kortere periode fra mars 1975 på «Arctic Surveyor» i arbeid i tilknytning til Ekofiskområdet og Emden-rørledningen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 133, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 133, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 133, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 8,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"1d236\", \"text\": \"Dykking på Gulftide\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 19, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"258c3\", \"text\": \"– Hvor fikk du oppdrag? – Etter noen måneder på borerigg utenfor Congo og Irland kom jeg i oktober 1972 til Gulftide på Ekofiskfeltet. Jeg dykket også på «Ocean Viking» på høstparten 1974, i forbindelse med omkoblingen til det nye Ekofisksenteret av de fire brønnene som opprinnelig produserte til Gulftide. Videre var jeg en kortere periode fra mars 1975 på «Arctic Surveyor» i arbeid i tilknytning til Ekofiskområdet og Emden-rørledningen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 441, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 441, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"49367\", \"text\": \"– Hva gikk jobben på Gulftide ut på?\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 36, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 36, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"8772b\", \"text\": \"– Da jeg kom til Ekofisk første gang, i oktober 1972, var Gulftide den eneste installasjonen i produksjon der ute. Dette var en «Jack Up» rigg, lett modifisert for å funksjonere som midlertidig produksjonsplattform mens byggefasen for de første «permanente» installasjonene for boring, produksjon, lagring og innkvartering pågikk.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 330, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 330, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"65e7f\", \"text\": \"Gulftide produserte fra de fire første lete- og avgrensningsbrønnene som ble boret på feltet, (2/4-1, 2/4-2, 2/4-3 og 2/4-4), som alle hadde gitt rike forekomster. Oljen og gassen ble ført i rørledninger til Gulftide. Her ble olje, gass (og vann) separert. Oljen ble ført videre i rørledninger til to lastebøyer, mens gassen ble brent i en «flare» over toppen av Gulftide`s borederrick. Dykkerteamet, som besto av seks mann, var fast stasjonert på Gulftide, men arbeidsoppgavene omfattet langt mer enn dykking på/ fra selve plattformen. Kort oppregnet var dykkerteamets arbeidsoppgaver som følger:\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 597, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 597, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"5cd1c\", \"text\": \"1. På/fra Gulftide: Regelmessige inspeksjoner av bunnen nær plattformbena for å oppdage erosjon i tide, og motvirke dette ved hjelp av sandsekker. Inspeksjon av baseplaten for stigerørene i forhold til erosjon, og av flenskoblingene på oljerørene til lastebøyene. Reparasjon hvis noe var galt (for eksempel pakningsskifte i flenskoblingene). Lekkasje oppsto her i alle fall en gang.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 382, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 382, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"bf95b\", \"text\": \"2. På/fra det av de faste servicefartøyene som til enhver tid befant seg på feltet: Inspeksjoner og vedlikehold på lastebøyene og deres forankringssystemer. Fortøyningsutstyret og lasteslangene til tankskipene var også dykkerteamets ansvar når problemene med disse oversteg hva servicefartøyenes besetning kunne utrette. Fortøyningstrossa og lasteslangen lå og fløt i sjøen, for opp-plukking til tankbåtene når de kom for å laste. Nesten hver gang det hadde blåst kuling eller kraftigere var slange og trosse viklet inn i hverandre og måtte skilles. Ikke så rent sjelden var hele eller deler av lasteslangen avslitt og borte, og måtte settes i stand igjen så snart vær og bølgehøyde tillot. Servicefartøyene het «Imkenturm» og «Pagenturm». De byttet på å være i beredskap på feltet. «Imkenturm» var utstyrt med et klokkesystem, samt for overflateorientert dykking. «Pagenturm» var utstyrt kun for overflateorientert dykking.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 924, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 924, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"47528\", \"text\": \"3. Ved oppdukkende behov på kranbarge «Choctaw 1» ble dykkerteamet midlertidig overflyttet dit. «Choctaw 1» ble i det meste av 1972 og frem til i mars 1973 benyttet i plassering og bunnfesting (pæling) av de fleste plattform- og bro- understellene (Jacketene) på det som skulle bli «Ekofiskbyen». Når det var undervannsarbeider i stort omfang var «Choctaw» bemannet med eget dykkerteam. Ved behov mellom større planlagte undervannsarbeider, ble den dykkerbemannet midlertidig ved omplassering av Gulftide teamet. «Choctaw 1» var utstyrt med et klokkesystem som ble brukt en del på de dypere arbeidene. Hoveddelen av dykkingen ble imidlertid gjort som overflateorientert dykking. Dette også til bunndybde. (Den gangen ca 72 meter. Mer dypere etter hvert på grunn av innsynkning.)\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 778, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 778, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "image",
              "imagePath": "https://ems-test.dimu.org/image/062waVTfUhhh?dimension=2048x2048",
              "altText": "Dykking på Gulftide",
              "caption": "Gulftide",
              "showCaptionIcon": true,
              "textAlign": "center"
            },
            {
              "type": "image",
              "imagePath": "https://ems-test.dimu.org/image/062waVTdyiHL?dimension=2048x2048",
              "altText": "Dykking på Gulftide",
              "caption": "dykking,",
              "showCaptionIcon": true,
              "textAlign": "center"
            },
            {
              "type": "image",
              "imagePath": "https://ems-test.dimu.org/image/062waVTfThBb?dimension=2048x2048",
              "altText": "Dykking på Gulftide",
              "caption": "Første brostøtte satt ned, forsidebilde, historie,",
              "showCaptionIcon": true,
              "textAlign": "center"
            }
          ]
        }
      ]
    },
    {
      "title": "Et risikabelt yrke",
      "type": "sticky",
      "order": 9,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTdyiHL?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"b5623\", \"text\": \"ET RISIKABELT YRKE\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 18, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 18, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 18, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"10f80\", \"text\": \"Våt og underkjølt, «mere død enn levende», kom jeg tilbake på dekk for å påbegynne et 4 – 5 timers opphold i overflatekammeret.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 127, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 127, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 127, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 10,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"a6b8c\", \"text\": \"Et risikabelt yrke\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 18, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 18, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 18, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"60b66\", \"text\": \"– Et av mine verste dykk var nettopp fra «Choctaw 1», i forbindelse med kutting av pælene på ca 53 – 54 meters dyp på Ekofisk 2/4 Q plattformen, etter at pælingen var fullført. Jobben ble gjort på luft, noe som førte til at jeg på dette dykket pådro meg en mer enn alminnelig kraftig dybderus og ble sittende fast.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 314, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 314, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"d931b\", \"text\": \"Tilførselsslangen for luft satte seg fast i plattformunderstellet. Det var en svært ubehagelig opplevelse. Etter en liten evighet kom jeg meg løs igjen ved egen hjelp, men jeg hadde brukt så mye tid på dette at dekompresjonen i sjøen tok i overkant av tre timer. Dette i en tørrdrakt som allerede under nedstigningen hadde vist seg å ha en nokså stor lekkasje i ryggen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 369, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 369, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"9a302\", \"text\": \"Våt og underkjølt, «mere død enn levende», kom jeg tilbake på dekk for å påbegynne et 4 – 5 timers opphold i overflatekammeret. Bevisstheten etterpå, om å ha bundet opp et helt dykkerteam og en hel konstruksjonsbarge i nærmere 12 timer med godt dykkevær, uten å ha utrettet noe som helst, var nesten like ubehagelig som å sitte fast mer enn 50 meter nede i Nordsjøen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 367, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 367, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"b1c0c\", \"text\": \"Det kunne være mange farlige situasjoner. En gang skulle jeg og noen andre heises opp fra et dykkerfartøy opp på plattformen via en basket. Men det var vanskelig å få fatt i basketen. Plutselig tårnet det seg opp en kjempehøy bølge foran dekk. Alle løp bakover dekket, bort fra bølgen, så raskt de kunne for å komme i sikkerhet. Men en svenske, Clason, skulle være lur og klatret opp på et høyt punkt og holdt seg fast. Problemet var bare at bølgen på vei over dekk sopte med seg materiell, gassflasker og annet som traff Clason i leggen og nesten knuste den. Det ble mye skriking, og Clason måtte unnsettes der ute i vannkavet. Han ble evakuert og sendt til sykehus noen timer senere, da været hadde lagt seg tilstrekkelig.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 724, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 724, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Ingen rutinejobb",
      "type": "sticky",
      "order": 11,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfThBb?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"7571c\", \"text\": \"INGEN RUTINEJOBB\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 16, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 16, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 16, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"02402\", \"text\": \"Da tok jeg bunnprøver for en vitenskapsmann, sittende i sanden på 72 meters dyp under «Pagenturm», med bøtte og spade.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 118, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 118, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 118, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 12,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"253ea\", \"text\": \"Ingen rutinejobb\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 16, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 16, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 16, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"70a35\", \"text\": \"– Kan du beskrive en typisk dag på jobb på Ekofisk? – Nei, jeg synes ingen dager var typiske. Dette fordi arbeidsoppgavene og stedene de ble utført var så varierte. Det kan ikke sies at vedlikeholdsdagene på dykkeutstyret, med ettersyn, vedlikehold og reparasjoner på personlig utstyr og det samme på klokke, kammer og kompressorer og winsjer etc. var typiske. For neste dag var det kanskje basketoverføring til servicefartøyet, tur over til en av lastebøyene for å slåss med lasteslange og trosse, eller et raskt SCUBA-dykk eller to for å måle skråningsvinkelen på en av lastebøyenes ankerkjettinger. Og så videre, osv. Den påfølgende natt kunne det like gjerne oppstå et eller annet som krevde dykkere et eller annet sted på feltet. Det er i grunnen lettere å beskrive den mest a-typiske dagen. Da tok jeg bunnprøver for en vitenskapsmann, sittende i sanden på 72 meters dyp under «Pagenturm», med bøtte og spade. Tanken gikk hen til barndommens strandliv med samme slags redskap.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 982, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 982, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"a04ee\", \"text\": \"– Hvordan var arbeidstidsordningen? – På Ekofisk / Gulftide 14 dager på og 14 dager av. Forlengelse av tiden på jobb kunne forekomme, da spesielt når arbeider på «Choctaw 1» krevde bemanning ut over det faste seks manns teamet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 227, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 227, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Best og verst med dykking",
      "type": "sticky",
      "order": 13,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNDv?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"a93cb\", \"text\": \"BEST OG VERST MED DYKKING\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 25, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 25, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 25, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"a682d\", \"text\": \"En var ikke alltid like mye «på alerten» verken i vannet eller på dekk under slike forhold.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 91, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 91, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 91, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 14,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"30626\", \"text\": \"Best og verst med dykking\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 25, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 25, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 25, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"38c36\", \"text\": \"– Hva var det beste med jobben? – Tilfredsheten, faktisk stoltheten over å få være med på noe som var spesielt. Ikke bare for meg selv som person, men fornemmelsen av at det var viktig for nasjonen Norge. Tilfredsheten over å merke at arbeidsoppgavene stort sett ble mestret. Det siste virker kanskje banalt å komme med, men man følte seg også litt privilegert fordi man hadde et arbeid som ga tilstrekkelig med adrenalinkicks, som det heter i dag, til at det aldri var noe behov for å kjøre villmann med bil eller hoppe ut av fly eller ned av fjellvegger på fritiden.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 568, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 568, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"52e63\", \"text\": \"– Hva var det verste? – Når det foregikk arbeider som krevde mange dype dykk kunne arbeidsøktene bli umenneskelig lange. 1 ½ – 2 døgn i strekk, en tur i dusjen og hodet på puta 5 – 6 – 7 timer, men så overtrøtt og mentalt forberedende en ny lang arbeidsøkt, at det ble dårlig med soving, påfulgt av nye 30 – 40 timers arbeid, var slett ikke uvanlig kost. En var ikke alltid like mye «på alerten» verken i vannet eller på dekk under slike forhold. Klart det gikk ut over sikkerheten. Men jobben skulle gjøres så andre kunne komme videre med sine jobber. Dog står det ikke til å nekte at når det kom dårlig vær som umuliggjorde dykking, så var det som en velsignelse rent. Eller som å bli reddet av gong-gongen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 709, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 709, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Uskrevne normer blant dykkerne",
      "type": "sticky",
      "order": 15,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTdyiHM?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"12157\", \"text\": \"USKREVNE NORMER BLANT DYKKERNE\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 30, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 30, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 30, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"06a4c\", \"text\": \"Det kunne eksempelvis vært godt å ha lover og bestemmelser å støtte seg til for eksempel når det gjaldt «maratonskiftene» som er beskrevet ovenfor.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 147, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 147, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 147, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 16,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"5cd24\", \"text\": \"Uskrevne normer blant dykkerne\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 30, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 30, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 30, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"62a5d\", \"text\": \"– Hvordan vil du beskrive arbeidsmiljøet? – Arbeidsmiljø, i dagens lovfastlagte og lovdefinerte HMS-forstand, eksisterte jo ikke. Men arbeidsmiljø var det jo. Etter egen oppfatning fungerte det helt av seg selv, etter den tidens uskrevne normer. Her noe overforenklet, men la gå: 1. Den jobben man hadde påtatt seg å gjøre, skulle gjøres. Greide man den ikke, måtte en annen gjøre den i stedet. 2. Når man oppdaget at en kollega hadde vanskeligheter, hjalp man ham i den grad det var praktisk mulig. Dette skapte en lagånd og lojalitet og årvåkenhet som jeg tror i stor grad kompenserte for manglende sikkerhetsbestemmelser på flere områder. Men ikke på alle. Det kunne eksempelvis vært godt å ha lover og bestemmelser å støtte seg til for eksempel når det gjaldt «maratonskiftene» som er beskrevet ovenfor. Men det hadde vi ikke. Landets styresmakter lå den gangen, og fortsatt i flere år etter Ekofiskutbyggingen i bitter indre strid om hvorvidt Lov om Arbeidervern av 1956 gjaldt på sokkelen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 995, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 995, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Litt om dykkerteknologi",
      "type": "sticky",
      "order": 17,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTdyiHH?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"8f6d9\", \"text\": \"LITT OM DYKKERTEKNOLOGI\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 23, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 23, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 23, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"231e0\", \"text\": \"var Kirby Morgan MK II den vanligst brukte masken både i overflateorientert dykking og i «lock outs» fra klokke.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 112, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 112, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 112, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 18,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"846ed\", \"text\": \"Litt om dykkerteknologi\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 23, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 23, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 23, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"bf988\", \"text\": \"– Hvilket utstyr brukte du? Hvordan behandlet du det?\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 53, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 53, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"f260a\", \"text\": \"– Så godt som alt, også den personlige utrustningen, var dykkeselskapets eiendom. Helt i begynnelsen var det vanlig at dykkeren medbrakte egen drakt til eget bruk. Dette ble det etter hvert gått bort fra. Hos Ocean Systems Inc. var Kirby Morgan MK II den vanligst brukte masken både i overflateorientert dykking og i «lock outs» fra klokke. Hos Comex var det Comex Pro, som i grunnen var svært lik KM, eller omvendt. Hvem som kopierte hvem, vet jeg ikke. I den overflateorienterte dykkingen ble også Yokohama gasshjelm brukt i en viss utstrekning. Den vanligst brukte drakten på denne tiden og frem til metningsdykkingen og dermed varmtvannsdrakten, fra 1975, var tørrdrakten Uni Suit fra Poseidon. Men flere varianter av Viking’s og Dunlop’s tørrdrakter var ganske vanlige. Det personlige utstyret ble selvfølgelig regelmessig ettersett, vedlikeholdt og reparert eller sendt til reparasjon. Det vil føre for langt å beskrive klokker, kammersystemer, maskineri og gassbanker her.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 979, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 979, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "image",
              "imagePath": "https://ems-test.dimu.org/image/062waVTfUMv8?dimension=2048x2048",
              "altText": "Litt om dykkerteknologi",
              "caption": "Arbeidsliv, dykking",
              "showCaptionIcon": true,
              "textAlign": "center"
            }
          ]
        }
      ]
    },
    {
      "title": "Dykking som karrierevei",
      "type": "sticky",
      "order": 19,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUMv8?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"f7bd5\", \"text\": \"DYKKING SOM KARRIEREVEI\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 23, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 23, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 23, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"bfb36\", \"text\": \"Da de omsider begynte å komme i sving, satt jeg «på motsatt side av bordet» i den lille befatning jeg hadde med dem.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 116, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 116, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 116, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 20,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"4f9b6\", \"text\": \"Dykking som karrierevei\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 23, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 23, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 23, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"aa3a3\", \"text\": \"– Hvilken type mennesker arbeidet du sammen med? Alder, kjønn, hvor kom de fra? – Diverse nasjonaliteter, med overvekt på briter. Dernest nordmenn og av og til en svenske eller danske. Dessuten en og annen franskmann, amerikaner, new zealender og australier. Kvinner forekom ikke verken på Ekofisk eller andre steder utaskjærs på denne tiden. Aldersmessig var det en overvekt av folk mellom 20 og 35 år.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 403, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 403, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"e28f4\", \"text\": \"– Hvilke karrieremuligheter fantes? – Utaskjærs gikk veien videre for ganske mange til dykkeleder «diving supervisor», og etter hvert som storskala metningsoperasjonene på dykkeskipene (DSVène) kom i gang opp over 1970 og 1980 tallet: Dykkesjef «diving superintendent», «life support technician», «gas technician». På land var lenge dykkeselskapenes landadministrasjoner, til dels også operatørselskapenes prosjekt organisasjoner steder hvor folk med dykkebakgrunn var til dels ettertraktede.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 492, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 492, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"e2da6\", \"text\": \"– Hva har fagforeningen betydd for deg? – Faktisk ingenting. Det fantes ingen sådanne med noen tilknytning til dykkerne før etter min dykkeraktive periode. Da de omsider begynte å komme i sving, satt jeg «på motsatt side av bordet» i den lille befatning jeg hadde med dem.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 272, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 272, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"de6f9\", \"text\": \"– Hadde jobbturnusen i oljeindustrien spesiell innflytelse på familielivet? – Det hadde den kanskje. Likevel må jeg peke på at med utaskjærs turnusene hadde jeg desto mer kontakt med kone og barn i friperiodene. Etter at jeg begynte å arbeide på land ble det mye tid på kontoret, hver eneste dag. Gjerne også i helger. Møter til sent på kveld. Mye reising. «Jobbrelatert pliktmessig selskapelighet». Ukependling i lange perioder. Alt i alt ble det vel ikke mer kvalitetstid med familien som landbasert.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 502, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 502, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"e5e97\", \"text\": \"– Når sluttet du å dykke? – Jeg arbeidet som dykker i Nordsjøen fram til ca. 1978. Deretter arbeidet jeg med administrative oppgaver på land. Jeg dykket senere en kort periode, men kuttet så ut dykkingen for godt. Jeg har jobbet i diverse firma, blant annet som personellkonsulent. Den siste jobben var å drive en egen bensinstasjon. I 1999 fikk jeg et lite slag og ble arbeidsufør.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 382, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 382, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    }
  ]
};

export const demo09_nordsjodykking = demo09;
